interface DialBackCTAProps {
  onGetAccess: () => void;
}

export default function DialBackCTA({ onGetAccess }: DialBackCTAProps) {
  return (
    <section
      className="py-32 px-12 border-t border-white/[0.06] text-center relative overflow-hidden max-md:px-6 max-md:py-20"
      style={{ background: '#0e0d0b', fontFamily: "'Instrument Sans', sans-serif" }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 60% 70% at 50% 50%, rgba(200,71,42,0.07) 0%, transparent 70%)',
        }}
      />

      <h2
        className="font-light leading-[1.1] text-[#f5f2ec] max-w-[700px] mx-auto mb-6 relative"
        style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 'clamp(2.5rem, 5vw, 4.5rem)' }}
      >
        Time travel is a gift.<br />
        <em className="italic text-[#9a9488]">Your calendar doesn&apos;t have to pay for it.</em>
      </h2>

      <p className="text-[1rem] text-[rgba(245,242,236,0.55)] max-w-[480px] mx-auto mb-10 leading-[1.7] relative">
        Join the beta. Founder pricing locked for life. First access to every feature as it ships. Direct line to shape what Jessica becomes next.
      </p>

      <div className="flex justify-center gap-4 flex-wrap relative">
        <button
          onClick={onGetAccess}
          className="text-[13px] font-semibold tracking-[0.1em] uppercase text-[#0e0d0b] bg-[#f5f2ec] px-8 py-4 rounded-sm transition-all duration-200 hover:bg-[#c8472a] hover:text-[#f5f2ec] hover:-translate-y-px whitespace-nowrap cursor-pointer"
        >
          Get early access — $49/mo
        </button>
        <a
          href="https://www.linkedin.com/posts/petergits_its-905-am-the-meeting-started-five-minutes-activity-7445455146685255680-foCp?utm_source=share&utm_medium=member_desktop&rcm=ACoAAABacG8B2S0Wl80pkWQ6ldVyN_dPahyhizY"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="text-[13px] font-semibold tracking-[0.08em] uppercase text-[#f5f2ec] bg-transparent border border-white/20 px-7 py-4 rounded-sm no-underline transition-all duration-200 hover:border-white/60 hover:bg-white/5 whitespace-nowrap cursor-pointer"
        >
          Like or comment on LinkedIn
        </a>
      </div>
    </section>
  );
}
